import { Button } from "react-bootstrap";

const GeneralExpensesHeader = ({ searchTerm, onSearchChange, total, onAddGeneralExpense }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">General Expenses ({total})</h4>

      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search expenses"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        <Button type="button" onClick={onAddGeneralExpense}>
          + Add Expense
        </Button>
      </div>
    </div>
  );
};

export default GeneralExpensesHeader;
